export default "__VITE_ASSET__DFNFKHhR__"